import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import { Search } from 'lucide-react';
import classes from "./Region.module.css"
import plus from "../../../../../Assets/plus.svg"
import ReportBackground from "../../../../../Assets/report.svg"
import run from "../../../../../Assets/run.svg"
import MailLogo from "../../../../../Assets/mail.svg"
import PrintLogo from "../../../../../Assets/print.svg"
import DownloadLogo from "../../../../../Assets/down.svg"
import BackLogo from "../../../../../Assets/back.svg"
import RotatingLogo from '../../../../../Assets/rotating-logo.png'
import EyeIcon from "../../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../../Components/Styles/API/API";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../../../Assets/download1.svg"
import upload from "../../../../../Assets/upload.svg"
import logo from "../../../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { FaFilePdf } from "react-icons/fa";
import { FaFileExcel } from "react-icons/fa";

const Region = () => {
  const location = useLocation();
  const [noData, setNoData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [load, setLoad] = useState(false);
  const [ledgerData, setLedgerData] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedContinent, setSelectedContinent] = useState('');
  const [tableData45, setTableData45] = useState([]);
  const [totalDebit, setTotalDebit] = useState('');
  const [totalCredit, setTotalCredit] = useState('');
  const [allAccounts, setAllAccounts] = useState([]);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [roleLoading, setRoleLoading] = useState(false);
  const [user, setUser] = useState('');
  const [error, setError] = useState(null);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [cashbook, setCashbook] = useState([]);
  const [tableData, setTableData] = useState([]);
  const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [currentMonth, setCurrentMonth] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [admin, setAdmin] = useState('');
  const [isPrinting, setIsPrinting] = useState(false);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [allAccountsData, setAllAccountsData] = useState([]);

  // Add the missing formatDate function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const handleExportExcel = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(dataToExport.map(item => ({
      "Region": item.description || "",
      "Continent": item.continent?.description || "",
      "Created Date": formatDate(item.created_at),
      "Updated Date": formatDate(item.updated_at),
    })));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Regions");
    XLSX.writeFile(workbook, "regions.xlsx");
  };

  // Export to PDF function
  const handleExportPDF = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Regions List", 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    const tableData = dataToExport.map(item => [
      item.description || "",
      item.continent?.description || "",
      formatDate(item.created_at),
      formatDate(item.updated_at),
    ]);

    doc.autoTable({
      head: [['Region', 'Continent', 'Created Date', 'Updated Date']],
      body: tableData,
      startY: 30,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 139, 202] }
    });

    doc.save("regions.pdf");
  };

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const current = await localStorage.getItem('currentMonth');
      const admins = await localStorage.getItem('admin');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }

      if (value1 !== null) {
        setUser(value1);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
        setCurrentMonth(date);
        const startOfDateRange = new Date(1900, 0, 1);
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
      if (admins !== null) {
        setAdmin(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  useEffect(() => {
    const handleBeforePrint = () => setIsPrinting(true);
    const handleAfterPrint = () => setIsPrinting(false);

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  // Fetch regions data with pagination and continent filtering
  const fetchRegionsData = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/regions`;
      let params = {
        page,
        per_page: entriesPerPage,
        ...(searchTerm && { search: searchTerm })
      };

      // If continent filter is selected, use the filter endpoint
      if (selectedContinentFilter && selectedContinentFilter.value !== 'all') {
        url = `${BASE_URL}/regions/get-by-continent`;
        params.continent_id = selectedContinentFilter.value;
      }

      const response = await axios.get(url, {
        headers,
        params
      });

      const data = response.data?.data;
      if (data) {
        // Handle different response structures
        const regionsData = data.data || data.regions || data || [];
        setTableData(regionsData);
        setAllAccountsData(regionsData);
        setTotalEntries(data.total || regionsData.length);
        setTotalPages(data.last_page || 1);
        setCurrentPage(data.current_page || page);
        console.log("Regions data:", regionsData);
      } else if (response.data?.regions) {
        const regionsData = response.data.regions;
        setTableData(regionsData);
        setAllAccountsData(regionsData);
        setTotalEntries(regionsData.length);
        setTotalPages(1);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setTableData([]);
      setAllAccountsData([]);
      Swal.fire({
        title: "Error",
        text: "Failed to fetch regions data",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  // Fetch continents for filter
  const fetchContinents = async () => {
    try {
      if (!bearer) return;
      setFiltersLoading(true);

      const response = await axios.get(`${BASE_URL}/continents`, { headers });

      let continentsData = [];
      if (response.data.status) {
        continentsData = response.data.data || [];
      } else if (Array.isArray(response.data)) {
        continentsData = response.data;
      } else if (response.data.data) {
        continentsData = response.data.data || [];
      } else {
        continentsData = [];
      }

      // Add "All" option to continents
      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...continentsData.map(continent => ({
          value: continent.id,
          label: continent.description || 'Unnamed Continent'
        }))
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      console.error("Error fetching continents:", error);
      setContinents([{ label: "All Continents", value: "all" }]);
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchRegionsData();
      fetchContinents();
    }
  }, [bearer]);

  // Auto-fetch regions when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      fetchRegionsData(1);
    }
  }, [selectedContinentFilter, bearer]);

  // Handle continent filter change
  const handleContinentChange = (selectedOption) => {
    setSelectedContinentFilter(selectedOption);
    setCurrentPage(1);
  };

  // Filter data based on search term
  const filteredData = tableData.filter(item =>
    item.description?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
    item.continent?.description?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const startIndex = (currentPage - 1) * entriesPerPage + 1;
  const endIndex = Math.min(currentPage * entriesPerPage, totalEntries);
  const displayedData = filteredData;

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleMail = () => alert("Mail clicked!");
  const handlePrinter = () => window.print();

  const handleDownload = () => {
    const dataToExport = displayedData.length > 0 ? displayedData : tableData;

    if (dataToExport.length === 0) {
      Swal.fire({
        title: "No Data",
        text: "There is no data to export.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const csvContent = [
      ["Region", "Continent", "Created Date", "Updated Date"],
      ...dataToExport.map(d => [
        d.description || "",
        d.continent?.description || "",
        formatDate(d.created_at),
        formatDate(d.updated_at),
      ])
    ].map(e => e.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "regions.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const formattedTotalEntries = totalEntries.toLocaleString();

  // Prepare options for react-select
  const continentOptions = continents;

  // Pagination handlers
  const handlePrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      fetchRegionsData(newPage);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      fetchRegionsData(newPage);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchRegionsData(page);
  };

  // Pagination component
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`${classes.pageButton} ${currentPage === i ? classes.activePage : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className={classes.paginationContainer}>
        <div className={classes.paginationControls}>
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className={classes.pageButton}
          >
            Previous
          </button>

          {pages}

          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className={classes.pageButton}
          >
            Next
          </button>

          <span className={classes.pageText}>
            Displaying {startIndex} - {endIndex} of {formattedTotalEntries}
          </span>
        </div>
      </div>
    );
  };

  const tableRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => navigate(-1)} />
        </div>

        <div style={{ marginTop: 12 }} />

        <div className={classes.topNavBars}>
          <div className={classes.filterRow}>
            <div className={classes.filterInputs}>
              <div className={classes.inlineField}>
                <label className={classes.inlineLabel}>Continent:</label>
                <Select
                  onChange={handleContinentChange}
                  options={continentOptions}
                  value={selectedContinentFilter}
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                  placeholder="Select Continent"
                />
              </div>
            </div>

          </div>
          <div className={classes.searchInputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={classes.searchInput}
              placeholder="Search regions..."
            />
            <Search className={classes.searchIcon} size={16} />
          </div>
        </div>

        <div style={{ marginTop: 24 }} />

        <div className={classes.containere}>
          <div className={classes.iconbars}>
            <div className={classes.iconbarss}>
              <div className={classes.iconbar} onClick={handleMail} style={{ cursor: "pointer" }}>
                <img src={MailLogo} alt="icon1" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                <img src={PrintLogo} alt="icon2" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleDownload} style={{ cursor: "pointer" }}>
                <img src={DownloadLogo} alt="icon3" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleExportPDF} style={{ cursor: "pointer" }}>
                <FaFilePdf size={20} color="#FF0000" className={classes.iconBtns} />
              </div>
              <div className={classes.iconbar} onClick={handleExportExcel} style={{ cursor: "pointer" }}>
                <FaFileExcel size={20} color="#217346" className={classes.iconBtns} />
              </div>
            </div>
          </div>

          <div className={classes.tableContainer}>
            <table className={classes.tableTable}>
              <thead className={classes.tableHeader}>
                <tr>
                  <th>#</th>
                  <th>Region</th>
                  <th>Continent</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  Array.from({ length: 7 }).map((_, index) => (
                    <tr key={`skeleton-${index}`}>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                      <td className={classes.textby}><Skeleton height={20} /></td>
                    </tr>
                  ))
                ) : displayedData.length > 0 ? (
                  displayedData.map((item, index) => (
                    <tr key={item.id || index}>
                      <td className={classes.textby}>{startIndex + index}</td>
                      <td className={classes.textby}>
                        {item.description || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {item.continent?.description || 'N/A'}
                      </td>
                      <td className={classes.textby}>
                        {formatDate(item.created_at)}
                      </td>
                      <td className={classes.textby}>
                        {formatDate(item.updated_at)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-4">
                      {loading ? "Loading regions..." :
                        searchTerm ? "No regions found matching your search" :
                          "No regions available"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && renderPagination()}
          </div>
        </div>
      </div>

      {savingsLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
    </div>
  );
};

export default Region;